import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type VatStatusViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  description_esValue?: { displayId: string; id: string } | null;
  description_es: string;
  description_enValue?: { displayId: string; id: string } | null;
  description_en: string;
  description_ptValue?: { displayId: string; id: string } | null;
  description_pt: string;
};

export const VatStatusViewForm: React.FC<VatStatusViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name_es = "",
    name_en = "",
    name_pt = "",
    description_es = "",
    description_en = "",
    description_pt = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupVatStatusLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name_es}
                label={langStore.VatStatusNameLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={name_en}
                label={langStore.VatStatusNameLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={name_pt}
                label={langStore.VatStatusNameLabel + " (pt)"}
              />
              <ShowMultiLine
                value={description_es}
                label={langStore.VatStatusDescriptionLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={description_en}
                label={langStore.VatStatusDescriptionLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={description_pt}
                label={langStore.VatStatusDescriptionLabel + " (pt)"}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
